<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <!-- Form -->
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md3 class="pr-4">
                <v-autocomplete
                  label="Voucher Type"
                  item-text="name"
                  item-value="name"
                  v-model="formSchema.voucher_type"
                  :items="voucherTypeList"
                  :rules="[v => !!v || 'Field is required']"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pr-4">
                <v-autocomplete
                  label="Currency Code"
                  item-text="name"
                  item-value="name"
                  v-model="formSchema.currency_code"
                  :items="currencyCode"
                  :rules="[v => !!v || 'Field is required']"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pr-4">
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'voucher_date', fieldValue:formSchema.voucher_date, label:'Voucher Date', required:1}"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm3 md3 class="pr-4">
                <v-text-field
                  label="USD Rate"
                  v-model="formSchema.usd_rate"
                  :rules="[v => !!v || 'Field is required']"
                  type="number"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md6 sm6>
                <v-textarea solo name="input-7-4" label="Narration" v-model="formSchema.narration">></v-textarea>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-checkbox v-model="formSchema.is_post" label="Is Posting" :value="isActiveVal"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- /Form -->

      <v-card class="mb-3 mt-3" color="lighten-1">
        <v-card-title>
          <span class="headline">Voucher Details</span>
          <v-btn class="float-right" color="success" @click.native="addDetails">
            <v-icon>save</v-icon>Add
          </v-btn>
        </v-card-title>

        <table border="1" class="partner_tbl" style="width:95%; margin-left:30px">
          <tr>
            <th>Echo Code</th>
            <th>Echo Name</th>
            <th>TR Debit</th>
            <th>TR Credit</th>
            <th>Source Of Fund</th>
            <th>Action</th>
          </tr>
          <tr v-for="(details,index) in formSchema.details" :key="index">
            <td>
              <v-flex xs12 class="pr-2">
                <v-autocomplete
                  item-text="eco_account_name"
                  item-value="id"
                  v-model="details.eco_head_id"
                  :items="economicList"
                  :rules="[v => !!v || 'Field is required']"
                  @change="setName(index)"
                ></v-autocomplete>
              </v-flex>
            </td>
            <td>
              <v-flex xs12 class="pr-2">
                <v-text-field label="Economic Code" v-model="details.eco_code" readonly></v-text-field>
              </v-flex>
            </td>
            <td>
              <v-flex xs12 class="pr-2">
                <v-text-field
                  v-model="details.transaction_debit"
                  :rules="[v => !!v || 'Field is required']"
                  type="number"
                ></v-text-field>
              </v-flex>
            </td>
            <td>
              <v-flex xs12 class="pr-2">
                <v-text-field
                  v-model="details.transaction_credit"
                  :rules="[v => !!v || 'Field is required']"
                  type="number"
                ></v-text-field>
              </v-flex>
            </td>
            <td>
              <v-flex xs12 class="pr-2">
                <v-autocomplete
                  item-text="name"
                  item-value="name"
                  v-model="details.fund_source"
                  :items="fundSource"
                  :rules="[v => !!v || 'Field is required']"
                ></v-autocomplete>
              </v-flex>
            </td>
            <td>
              <!-- <v-btn icon class="mx-0" @click="details(val.id)">
              <v-icon color="teal">remove_red_eye</v-icon>
              </v-btn>-->
              <!-- <v-btn icon class="mx-0" @click="editItem(index, val)">
              <v-icon color="teal">edit</v-icon>
              </v-btn>-->
              <v-btn icon class="mx-0" @click="deleteDetails(index)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.native="backtolist">
            <v-icon>refresh</v-icon>
            {{resetButton}}
          </v-btn>
          <v-btn color="success" @click.native="validateBeforeSubmit">
            <v-icon>save</v-icon>
            {{ buttonTitle }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";
import Axios from "axios";

export default {
  components: { DatePicker },
  data: () => ({
    valid: true,
    isActiveVal: 1,
    parameterTypes: [],
    voucherTypeList: [
      {name: "Payment"}, 
      {name: "Re-Payment"},
      {name:'Fund Released'},
      {name:'Withdrawal'},
      {name:'Refund'},
      {name:'Transfer To GoB'},
      {name:'Fund Receive'}
    ],
    economicList: [],
    fundSource: [{ name: "IDA" }, { name: "GoV" }],
    currencyCode: [{ name: "BDT" }, { name: "USD" }],
    formSchema: {
      id: 0,
      operation_id: "",
      voucher_type: "",
      currency_code: "",
      usd_rate: "",
      voucher_date: "",
      narration: "",
      is_post: 0,
      details: [
        {
          eco_head_id: "",
          eco_code: "",
          transaction_debit: "",
          transaction_credit: "",
          fund_source: ""
        }
      ]
    },

    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
      { text: "Type Name", align: "left", sortable: true, value: "type_name" },
      {
        text: "Short Name",
        align: "left",
        sortable: true,
        value: "short_name"
      },
      { text: "Action", align: "center", value: "" }
    ],
    /*------------- /Datatable ---------------*/

    delete_id: "",
    row_index: "",
    dialog2: false,

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    }
  }),

  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? "Edit Voucher" : "Add Voucher";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },
    resetButton() {
      return this.formSchema.id > 0 ? "Go To List" : "Go To List";
    },

    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },
  /*------------/Datatable------------*/

  // Page Load Before Called Mathodes =========================================
  created() {
    let root = this;
    // Get Eco Account dat
    commonService.getAllData("get_economic_info").then(res => {
      root.economicList = res.data;
    });
    // Form Edit section from Here ------------------------
    let voucher_id = sessionStorage.getItem("voucher_master_id");
    //let voucher_id = this.$store.getters.GET_VOUCHER_ENTRY_DATA;
    if (voucher_id > 0) {
      // Get Voucher Data
      commonService
        .getAllDataById(voucher_id, "get_voucher_master_data")
        .then(res => {
          this.formSchema = res.data;
          this.formSchema.voucher_date = this.changeFormateDMY(
            res.data.voucher_date
          );
          sessionStorage.removeItem("voucher_master_id");
          //this.$store.commit("UNSET_VOUCHER_ENTRY_DATA");
        });
    }
  },

  methods: {
    // Back to list page function
    backtolist() {
      this.$router.push("/project-info/voucher-master");
    },
    // Voucher Details row added
    addDetails() {
      this.formSchema.details.push({
        eco_head_id: "",
        eco_code: "",
        transaction_debit: "",
        transaction_credit: "",
        fund_source: ""
      });
    },
    // Voucher Details row deleted
    deleteDetails(index) {
      this.formSchema.details.splice(index, 1);
    },
    // Voucher form submitted
    validateBeforeSubmit(e) {
      let root = this;
      this.Loader = true;
      let formSchema = this.formSchema;
      // is_post value manage
      (formSchema.is_post == null) ? formSchema.is_post = 0 :'';
      formSchema.voucher_date = root.changeFormateYMD(
        this.formSchema.voucher_date
      );
      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "voucher_master")
            .then(res => {
              this.close(res);
            });
        } else {
          //console.log(formSchema.asset_status);
          commonService
            .insertFormData(this.formSchema, "voucher_master")
            .then(res => {
              this.close(res);
            });
        }
      }
    },
    // onchange economic code name selected
    setName(obj) {
      //alert(index);
      var eco_id = this.formSchema.details[obj].eco_head_id;
      var index = this.economicList
        .map(function(e) {
          return e.id;
        })
        .indexOf(eco_id);
      var economic_code = this.economicList[index].eco_account_code;
      this.formSchema.details[obj].eco_code = economic_code;
    },

    // Set Date Value
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },
    // Close function from here
    close(res) {
      let $this = this;
      this.SnackbarVal.color = "success";
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
      if (!this.formSchema.id > 0) {
        this.$refs.form.reset();
      }
    }
  }
};
</script>

<style scoped>
table.paySchedule {
  width: 100%;
  border-collapse: collapse;
}
.paySchedule td {
  border: 1px solid #ccc;
  line-height: 41px;
  text-align: center;
  text-align: center;
}
.paySchedule tr.tb-td td {
  font-weight: bold;
}
td.textCenter {
  text-align: center;
}
td.textRight {
  text-align: right;
}
td input {
  width: 100%;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/project_info/Voucher/voucher_form.vue